import React from "react";

const PropertyDoubleInput = (props) => {
  return (
    <>
      <p htmlFor={props.id}className="property-header">
        {props.title}
      </p>
      <input
        className="form-control form-control-sm"
        id={props.id}
        value={props.value}
        type="text"
        disabled={props.disabled}
        aria-label=".form-control-sm example"
        onChange={props.handler}
      ></input>
      {props.error && <div className="input-error-tooltip">{props.error}</div>}
    </>
  );
};

export default PropertyDoubleInput;
